// assets/js/navigation.js
// Dropdown menus and mobile navigation toggle. No dependencies.

// --- Footer email form ---
document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.footer-email-form');
  if (!form) return;

  var PORTAL_ID = '8440776';
  var FORM_GUID  = '127614dc-f639-404e-a850-fd8908697f26';

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var email     = form.querySelector('input[type="email"]').value;
    var submitBtn = form.querySelector('.btn--primary');

    submitBtn.disabled    = true;
    submitBtn.textContent = 'Submitting…';

    fetch(
      'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + FORM_GUID,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fields: [{ name: 'email', value: email }],
          context: { pageUri: window.location.href, pageName: document.title }
        })
      }
    ).then(function (response) {
      if (!response.ok) throw new Error('failed');

      var thanks = document.createElement('p');
      thanks.className   = 'footer-email-thanks';
      thanks.textContent = 'Thanks for signing up!';
      form.parentNode.insertBefore(thanks, form);
      form.style.display = 'none';
    }).catch(function () {
      submitBtn.disabled    = false;
      submitBtn.textContent = 'Stay Informed';
      alert('Something went wrong. Please try again.');
    });
  });
});

// --- Footer column accordion nav ---
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('footer .wp-block-column').forEach(function (col) {
    var h3  = col.querySelector('h3');
    var nav = h3 && col.querySelector('nav');
    if (!h3 || !nav) return;
    if (nav.querySelectorAll('li').length < 1) return;
    if (h3.classList.contains('u-no-accordion')) return;

    h3.classList.add('is-accordion-toggle');
    nav.classList.add('is-accordion-nav');

    h3.addEventListener('click', function () {
      var open = h3.classList.contains('is-open');
      h3.classList.toggle('is-open', !open);
      nav.classList.toggle('is-open', !open);
    });
  });
});

(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var mobileToggle = header.querySelector('.site-header__mobile-toggle');
  var nav = header.querySelector('.site-header__nav');
  var overlay = header.querySelector('.site-header__overlay');
  var dropdownTriggers = header.querySelectorAll('.site-header__menu-link[aria-expanded]');
  var mobileNavigation = document.querySelector('.js-mobile-navigation');
  var mobileToggleItems = mobileNavigation
    ? mobileNavigation.querySelectorAll('.mobile-navigation__menu-item.-toggle')
    : [];

  // --- Mega nav ---
  //
  // Every item that has a panel opens it on hover and on keyboard focus, and
  // hovering one of the panel's links swaps which preview is shown. A trigger
  // with a page behind it is a real link, so a click still goes there - except
  // on a device with no hover, where the first tap has to open the panel
  // instead. A trigger with no page is a <button> and only ever opens.

  var HOVER_IN = 80;
  var HOVER_OUT = 180;
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
  var openTimer = null;
  var closeTimer = null;

  // Matches anything marked as carrying a panel rather than list items alone,
  // so the markup decides which items have one.
  var megaItems = header.querySelectorAll('[data-meganav-item]');

  megaItems.forEach(function (item) {
    // Matched on the class, not the tag: an item with no page of its own -
    // Solution - renders its trigger as a <button>, and an `a[...]` selector
    // here silently skipped it, leaving that panel with no hover at all.
    var trigger = item.querySelector('.site-header__menu-link[aria-expanded]');
    if (!trigger) return;

    item.addEventListener('mouseenter', function () {
      if (!canHover) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () {
        openDropdown(item, trigger);
      }, HOVER_IN);
    });

    item.addEventListener('mouseleave', function () {
      if (!canHover) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeAllDropdowns, HOVER_OUT);
    });

    // Keyboard: opening on focus lets a tab through the nav reveal each panel,
    // and the panel's own links are inside the item, so tabbing into them keeps
    // it open. Focus moving outside the item closes it.
    item.addEventListener('focusin', function () {
      clearTimeout(closeTimer);
      openDropdown(item, trigger);
    });

    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        closeAllDropdowns();
      }
    });

    trigger.addEventListener('click', function (e) {
      // Touch has no hover to open the panel with, so the first tap opens it
      // and a second follows the link.
      if (!canHover && !item.classList.contains('is-open')) {
        e.preventDefault();
        closeAllDropdowns();
        openDropdown(item, trigger);
      }
    });

    // --- Preview swapping ---
    var previews = item.querySelectorAll('[data-meganav-preview]');
    if (!previews.length) return;

    item.querySelectorAll('[data-meganav-target]').forEach(function (link) {
      function show() {
        showPreview(previews, link.getAttribute('data-meganav-target'));
      }
      link.addEventListener('mouseenter', show);
      link.addEventListener('focus', show);
    });

    // Deliberately no revert on leaving the list: the preview a link swaps in
    // carries its own button, over in the left column, and reverting the moment
    // the pointer left the link would take that button away while the user was
    // on their way to it. The preview a link raised therefore stays up until
    // another link raises a different one, or the panel closes.
  });

  function showPreview(previews, key) {
    var wanted = null;

    previews.forEach(function (preview) {
      if (preview.getAttribute('data-meganav-preview') === key) {
        wanted = preview;
      }
    });

    // A link with no preview of its own leaves the panel as it is rather than
    // emptying it.
    if (!wanted) return;

    previews.forEach(function (preview) {
      preview.hidden = preview !== wanted;
    });
  }

  var swapTimer = null;

  function openDropdown(item, trigger) {
    if (item.classList.contains('is-open')) return;

    // Going straight from one open panel to another: suppress the fade for both
    // so the shared background never dips between them.
    var alreadyOpen = header.querySelector('[data-meganav-item].is-open');
    if (alreadyOpen && alreadyOpen !== item) {
      header.classList.add('is-swapping');
      clearTimeout(swapTimer);
      swapTimer = setTimeout(function () {
        header.classList.remove('is-swapping');
      }, 250);
    }

    closeAllDropdowns();
    document.body.classList.add('is-dropdown-open');
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    positionDropdown(item);
  }

  // Reposition on resize so the panel keeps sitting under the header
  window.addEventListener('resize', function () {
    var openItem = header.querySelector('[data-meganav-item].is-open');
    if (openItem) positionDropdown(openItem);
  });

  // Push the panel below the actual header bottom (accounts for any header
  // height), then line the link list up under the nav item it belongs to -
  // which is what the design shows, and what no amount of CSS can work out on
  // its own from inside a full-width fixed panel.
  function positionDropdown(item) {
    var dropdown = item.querySelector('.site-header__dropdown');
    if (!dropdown) return;

    dropdown.style.paddingTop = Math.round(header.getBoundingClientRect().bottom) + 'px';

    var list = dropdown.querySelector('.site-header__dropdown-list');
    var trigger = item.querySelector('.site-header__menu-link');
    // The logo's panel carries no list, so there is nothing to line up.
    var content = dropdown.querySelector('.site-header__dropdown-content');
    if (!list || !trigger || !content) return;

    list.style.marginLeft = '';
    var offset = Math.round(
      trigger.getBoundingClientRect().left - content.getBoundingClientRect().left
    );
    list.style.marginLeft = Math.max(0, offset) + 'px';
  }

  // Close on click outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-meganav-item]')) {
      closeAllDropdowns();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
      closeMobileNav();
    }
  });

  function closeAllDropdowns() {
    clearTimeout(openTimer);

    header.querySelectorAll('[data-meganav-item].is-open').forEach(function (item) {
      item.classList.remove('is-open');

      var trigger = item.querySelector('[aria-expanded]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      var dropdown = item.querySelector('.site-header__dropdown');
      if (dropdown) {
        dropdown.style.paddingTop = '';
        var list = dropdown.querySelector('.site-header__dropdown-list');
        if (list) list.style.marginLeft = '';
      }

      // Next open starts from the panel's own content again.
      showPreview(item.querySelectorAll('[data-meganav-preview]'), 'default');
    });

    document.body.classList.remove('is-dropdown-open');
  }

  // --- Mobile Nav Toggle ---

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileNavigation.classList.contains('is-open');
      if (isOpen) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeMobileNav);
  }

  var mobileNavClose = document.querySelector('.mobile-navigation__close');
  if (mobileNavClose) {
    mobileNavClose.addEventListener('click', closeMobileNav);
  }

  // --- Mobile Accordion Menu ---
  // Each sub-menu heading is a <button> (WCAG 2.1.1), so Enter and Space open
  // it as well as a tap, and aria-expanded tells screen readers its state.
  mobileToggleItems.forEach(function (item) {
    var button = item.querySelector('.mobile-navigation__toggle-row');
    if (!button) return;
    button.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      mobileToggleItems.forEach(function (otherItem) {
        otherItem.classList.remove('is-open');
        var otherButton = otherItem.querySelector('.mobile-navigation__toggle-row');
        if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // --- Keep focus inside the open mobile menu ---
  // The menu covers the whole screen, so focus that leaves it lands on page
  // content nobody can see (WCAG 2.4.3, 2.4.11). Tab and Shift+Tab loop round
  // the menu's own controls while it is open.
  function mobileNavFocusables() {
    return Array.prototype.filter.call(
      mobileNavigation.querySelectorAll('a[href], button:not([disabled])'),
      function (el) {
        return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
      }
    );
  }

  if (mobileNavigation) {
    mobileNavigation.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !mobileNavigation.classList.contains('is-open')) return;
      var items = mobileNavFocusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function openMobileNav() {
    mobileNavigation.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.setAttribute('aria-label', 'Close menu');
    document.body.style.overflow = 'hidden';
    // Start keyboard and screen-reader users inside the menu, on its close button.
    if (mobileNavClose) mobileNavClose.focus();
  }

  function closeMobileNav() {
    var wasOpen = mobileNavigation.classList.contains('is-open');
    mobileNavigation.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    if (mobileToggle) {
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.setAttribute('aria-label', 'Open menu');
    }
    document.body.style.overflow = '';
    closeAllDropdowns();
    // Back to the button that opened it. Escape runs this on every page even
    // with the menu shut, so only move focus when the menu really closed.
    if (wasOpen && mobileToggle) mobileToggle.focus();
  }
})();
